import config from './config.js'
import firebase from 'firebase/app';
import 'firebase/database'; 
import 'firebase/storage'; 
import 'firebase/auth'; 
const FB_VALUE = 'value'
const FB_CHILDCHANGED = 'child_changed'
const app = firebase.initializeApp(config)
const auth = firebase.auth()
const db = app.database()
const USER_REF = db.ref('Users')
const storage = firebase.storage().ref();
const lookup = function (dbPath, callback) {
  var result = [];
  db.ref(dbPath).once(FB_VALUE).then(function (snapshot) {
    if (snapshot) {
      snapshot.forEach(function (childSnapshot) {
        result.push(childSnapshot.val())
      })
      callback(result);
    }
    else {
      return null
    }
  }).catch(err => console.log(err))
}

const lookupList = function (dbPaths, callback){
  var result = [];
  for(var i = 0; i < dbPaths.length; i++){
    let dbPath = dbPaths[i];
    db.ref(dbPath).once(FB_VALUE).then(function (snapshot) {
      if (snapshot) {
        snapshot.forEach(function (childSnapshot) {
          result.push(childSnapshot.val())
        })
      }
      else {
        return null
      }
    }).catch(err => console.log(err))
  }
  callback(result);
}

const bind = function (dbPath, callback) {
  db.ref(dbPath).on(FB_VALUE, function (snapshot) {
    var result = [];
    if (snapshot) {
      snapshot.forEach(function (childSnapshot) {
        if(childSnapshot)
        result.push(childSnapshot.val())
      })
      callback(result);
    }
    else {
      return null
    }
  })
}

const getUser = function(user){
  db.ref('Users/' + payload.uid).once("value").then(snapshot => {
    if (snapshot.val()) {
      console.log("Find user in firebase db success");
      commit(types.SET_USER, snapshot.val());
    }
    else {
      console.log("No user in the db, creating new entry");
      dispatch("createUserData", payload);
    }
  }).catch(err => { console.log(err) });
}


export default app
export { auth, storage, db, lookup , lookupList, bind, FB_VALUE}